import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = {
    apiUrl: String,
    videoId: String
  };

  report() {
    const data = {};
    data.bien_fit_pdf_click = { semana_healthy_bien_fit_video_id: this.videoIdValue };
    new FetchRequest('post', this.apiUrlValue, { body: JSON.stringify(data) }).perform();
  }
}
